import { logger } from 'logging';

export const FILTER_API_HIT_COUNT = 'FILTER_API_HIT_COUNT';
export const setFilterApiHitCount = () => {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    let currentCount = localStorage.getItem(FILTER_API_HIT_COUNT);
    if (currentCount !== null) {
      let count = Number(currentCount);
      currentCount = (count + 1).toString();
    } else {
      currentCount = '1';
    }
    localStorage.setItem(FILTER_API_HIT_COUNT, currentCount);
  } catch (err) {
    logger.error(err, 'Error setting item in local storage for API hit count');
  }
};
export const resetFilterApiHitCount = () => {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.setItem('FILTER_API_HIT_COUNT', '0');
  } catch (err) {
    logger.error(err, 'Error setting item in local storage for API hit count');
  }
};

export const getFilterApiHitCount = () => {
  if (typeof localStorage === 'undefined') {
    return 0;
  }
  try {
    let currentCount = localStorage.getItem(FILTER_API_HIT_COUNT);
    if (currentCount !== null) {
      return Number(currentCount);
    }
    return 0;
  } catch (err) {
    logger.error(
      err,
      'Error getting item from local storage for API hit count'
    );
    return 0;
  }
};
